import { Helmet } from 'react-helmet-async';

import RolesView from '../../sections/roles';

export default function RolesPage() {
  return (
    <>
      <Helmet>
        <title> Roles Management | Oryx One </title>
      </Helmet>
      <RolesView />
    </>
  );
}
